import React from 'react';
import {CartItemDataHook} from '../../CartItem';
import s from '../../CartItem.scss';
import {LineItemModel} from '../../../../../../domain/models/LineItem.model';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {getLineItemSubscriptionFrequencyText} from '../../../../../../domain/utils/getLineItemSubscriptionFrequencyText';
import {useControllerProps} from '../../../../../../domain/controllers/ControllerContext';

export const TotalPrice = ({
  lineItem,
  shouldShowCrossedOutPriceOnLineItemLevel,
}: {
  lineItem: LineItemModel;
  shouldShowCrossedOutPriceOnLineItemLevel: boolean;
}) => {
  const {supportSubscriptionsInPurchaseFlow} = useControllerProps().cartStore;

  const shouldDisplayFrequency =
    lineItem.subscriptionInfo && lineItem.subscriptionInfo.subscriptionSettings.billingCycles !== 1;

  const {t} = useTranslation();

  return supportSubscriptionsInPurchaseFlow ? (
    <div
      className={s.totalPrice}
      data-hook={CartItemDataHook.TotalPrice}
      data-wix-item-total-price={CartItemDataHook.TotalPrice}>
      <div className={s.priceRow}>
        {shouldShowCrossedOutPriceOnLineItemLevel && lineItem.crossedOutPrice?.formattedConvertedAmount && (
          <div data-hook={CartItemDataHook.ComparePriceOnLineItem} className={s.comparePrice}>
            {lineItem.crossedOutPriceByQuantity.formattedConvertedAmount}
          </div>
        )}
        <div className={s.totalPriceText}>{lineItem.lineItemPrice.formattedConvertedAmount}</div>
      </div>

      {shouldDisplayFrequency && (
        <div className={s.subscriptionFrequency} data-hook={CartItemDataHook.SubscriptionFrequency}>
          {getLineItemSubscriptionFrequencyText(t, lineItem.subscriptionInfo.subscriptionSettings)}
        </div>
      )}
    </div>
  ) : (
    <div
      className={s.totalPriceOld}
      data-hook={CartItemDataHook.TotalPrice}
      data-wix-item-total-price={CartItemDataHook.TotalPrice}>
      {shouldShowCrossedOutPriceOnLineItemLevel && lineItem.crossedOutPrice?.formattedConvertedAmount && (
        <div data-hook={CartItemDataHook.ComparePriceOnLineItem} className={s.comparePrice}>
          {lineItem.crossedOutPriceByQuantity.formattedConvertedAmount}
        </div>
      )}
      <div className={s.totalPriceText}>{lineItem.lineItemPrice.formattedConvertedAmount}</div>
    </div>
  );
};
